import { SetStateAction, Dispatch, createContext } from 'react';

export const currentModalContext = createContext<[string | null, Dispatch<SetStateAction<string | null>>]>([null, () => { throw new Error('you\'re not in a modal context'); }]);
